module.exports = __webpack_public_path__ + "img/cctvinspection_driving.35458532.svg";